$( document ).ready(function() {
    var incrementHex = 200; 
    var incrementScreen = 144;
    $("span.js-qty__adjust.js-qty__adjust--minus.quantity__minus.custom-hex-pencils").click(function(){
      let valueminus = $(this).next().val() - incrementHex ;
      if (valueminus > 200){
        $(this).next().val(valueminus);
      }
      if (valueminus <= 200){
        $(this).next().val(200);
      }
    });
  $("span.js-qty__adjust.js-qty__adjust--plus.quantity__plus.custom-hex-pencils").click(function(){
      let valueplus = $(this).prev().val()* 1;
      valueplus = valueplus + incrementHex ;
      $(this).prev().val( valueplus );
    });
    $("span.js-qty__adjust.js-qty__adjust--minus.quantity__minus.custom-screen-printed-pencils").click(function(){
      let valueminus = $(this).next().val() - incrementScreen;
      if (valueminus > 432){
        $(this).next().val(valueminus);
      }
      else {
        $(this).next().val(432);
      }
    });
    $("span.js-qty__adjust.js-qty__adjust--plus.quantity__plus.custom-screen-printed-pencils").click(function(){
      let valueplus = $(this).prev().val()* 1;
      valueplus = valueplus + incrementScreen;
      console.log(valueplus);
      $(this).prev().val( valueplus );
    });
});